"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataSetMetadataObject = void 0;
// (C) 2019-2020 GoodData Corporation
var types_1 = require("../types");
/**
 * Tests whether the provided object is of type {@link IDataSetMetadataObject}.
 *
 * @param obj - object to test
 * @public
 */
function isDataSetMetadataObject(obj) {
    return types_1.isMetadataObject(obj) && obj.type === "dataSet";
}
exports.isDataSetMetadataObject = isDataSetMetadataObject;
//# sourceMappingURL=index.js.map